<template>
  <CoachShell>
    <article v-if="selectedCoach">
        <!-- Profile header -->
        <div class="bg-gray-50">
          <!-- Cover photo (static) -->
          <div>
            <img class="h-32 w-full object-cover lg:h-48"
                 src="https://images.unsplash.com/photo-1550063873-ab792950096b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80"
                 alt="" />
          </div>
          <div class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="-mt-12 sm:-mt-16 sm:flex sm:items-end sm:space-x-5">
              <div class="flex">
                <img v-if="pic" class="h-24 w-24 rounded-full ring-4 ring-white sm:h-32 sm:w-32" :src="pic" alt="" />
                <span v-else class="inline-block h-24 w-24 rounded-full overflow-hidden bg-gray-100 ring-4 ring-gray-300 sm:h-32 sm:w-32">
                  <svg class="h-full w-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"></path>
                  </svg>
                </span>
              </div>
              <div class="mt-6 sm:flex-1 sm:min-w-0 sm:flex sm:items-center sm:justify-end sm:space-x-6 sm:pb-1">
                <div class="sm:hidden 2xl:block mt-6 min-w-0 flex-1">
                  <h1 class="text-2xl font-bold text-gray-900 truncate">
                    {{ fullName }}
                  </h1>
                </div>
                <div class="mt-6 flex flex-col justify-stretch space-y-3 sm:flex-row sm:space-y-0 sm:space-x-4">
                  <base-button link
                               :to="coachContactLink"
                               @click="toggleModal"
                               :class="'inline-flex justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500'"
                  >
                    <MailIcon class="-ml-1 mr-2 h-5 w-5 text-gray-400" aria-hidden="true" />
                    <span>Message</span>
                  </base-button>

                </div>
              </div>
            </div>
            <div class="hidden sm:block 2xl:hidden mt-6 min-w-0 flex-1">
              <h1 class="text-2xl font-bold text-gray-900 truncate">
                {{ fullName }}
              </h1>
            </div>
          </div>
        </div>

        <!--  Tabs -->
        <div class="">
          <div class="bg-gray-50 border-b border-gray-200">
            <div class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
              <nav class="-mb-px flex space-x-8 pt-6 sm:pt-2 2xl:pt-5" aria-label="Tabs">
                <a v-for="tab in tabs"
                   @click="setSelectedTab(tab.tabId)"
                   :key="tab.name"
                   :href="tab.href"
                   :class="[selectedTab === tab.tabId ? 'border-pink-500 text-gray-900' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm']"
                   >
                  {{ tab.name }}
                </a>

              </nav>
            </div>
          </div>
          <keep-alive>
            <component :is="selectedTab"
                       :areas="areas"
                       :rate="rate"
                       :description="description"
                       :coachId="selectedCoach.id"
            ></component>
          </keep-alive>
        </div>
        <router-view></router-view>
      </article>
  </CoachShell>
</template>

<script>
import CoachShell from "./CoachShell";
import CoachProfile from "./CoachProfile";
import CoachWorkSamples from "./CoachWorkSamples";
import { MailIcon, } from '@heroicons/vue/solid'

export default {
  components: {
    CoachShell,
    CoachProfile,
    CoachWorkSamples,
    MailIcon
  },
  props: ['id'], //todo get a prop with the name you assigned in the route
  data(){
    return{
      routeID: this.$route.params.id,
      selectedCoach: {}, //todo it will be null at first, but when the component is created we will get the data from the store
      coaches: this.$store.getters['coaches/coaches'],
      isModalOpen: false,
      tabs: [
        { name: 'Profile', href: '#', current: true, tabId: 'CoachProfile' },
        { name: 'Work Samples', href: '#', current: false, tabId: 'CoachWorkSamples' },
      ],
      selectedTab: 'CoachProfile',
    };
  },
  computed: {
    fullName() {
      return this.selectedCoach.firstName + ' ' + this.selectedCoach.lastName;
    },
    areas(){
      return this.selectedCoach.areas;
    },
    rate(){
      return this.selectedCoach.hourlyRate;
    },
    description(){
      return this.selectedCoach.description;
    },
    pic(){
      if(this.selectedCoach.pic) {
        //console.log(`pic for coach: ${this.selectedCoach.id}, ${this.selectedCoach.pic}`);
        return this.selectedCoach.pic;
      }
      else{
        //console.log(`ELSE NULL pic for coach: ${this.selectedCoach.id} should be null`);
        return '';
      }
    },
    coachContactLink() {
      //console.log(this.$route.path);
      return '/coaches/' + this.selectedCoach.id + '/contact'; // /coaches/c1
    },
  },
  methods: {
    toggleModal(){
      this.isModalOpen = !this.isModalOpen;
      //console.log('toggle modal', this.isModalOpen);
    },
    findCoachById(coachId){
      //console.log('called findCoachById', coachId);

      // if(this.coaches.length < 1){
      //   console.log('coaches are empty');
      //   this.$store.dispatch('coaches/loadCoaches');
      // }
      //
      // this.coaches = this.$store.state.coaches;
      // if(this.coaches.length < 1){
      //   console.log('coaches are empty AGAIN ');
      //   this.$store.dispatch('coaches/loadCoaches');
      // }
      //
      // console.log('store coaches:', this.$store.state.coaches);
      // console.log('store coaches getters:', this.$store.getters['coaches/coaches']);
      this.selectedCoach = this.$store.getters['coaches/coaches'].find(
          coach => coach.id === coachId
      );

      //console.log('selectedCoach from fn:', this.selectedCoach);
    },
    setSelectedTab(tab){
      this.selectedTab = tab;
    },
  },
  watch: {
    '$route.params.id': function() {
      //console.log('param from watcher ', this.$route.params.id);
      // this.selectedCoach = this.$store.getters['coaches/coaches'].find(
      //     coach => coach.id === this.$route.params.id
      // );
      this.findCoachById(this.$route.params.id);
      //console.log('param from watcher after method ', this.$route.params.id);
    },
    // id(){
    //   this.findCoachById(this.id);
    // }
  },
  mounted(){
    // console.log('param from mounted ', this.$route.params.id);
    //this.findCoachById(this.$route.params.id);
    //console.log(this.coaches);
  },
  created() {
    //console.log('param from created ', this.$route.params.id);
    //this.$store.dispatch('coaches/loadCoaches');
    //this.coaches = this.$store.getters['coaches/coaches'];
    this.findCoachById(this.id);
    // this.selectedCoach = this.$store.getters['coaches/coaches'].find(
    //     coach => coach.id === this.id
    // );
  }
}
</script>